import api from '.';
import { PaginationProps } from '../common/interface/pagination';

interface GetWorkflowStepParams extends PaginationProps {}

interface CreateWorkflowStep {
  name: string;
  order: number;
  isInternal: boolean;
  canStopWorkflow: boolean;
  isFinalApprover: boolean;
  isChecklist: boolean;
}

interface UpdateWorkflowStep extends CreateWorkflowStep {
  id: number | null;
}

export async function getWorkflowSteps() {
  const { data } = await api.get('/workflow-steps');
  return data;
}

export async function getWorkflowStepsMasterData(
  params: GetWorkflowStepParams
) {
  const { data } = await api.get('/workflow-steps/master-data', {
    params
  });
  return data;
}

export async function getWorkflowStepWithPositions() {
  const { data } = await api.get('/workflow-steps/project-positions');
  return data;
}

export async function getWorkflowStep(id: number) {
  const { data } = await api.get(`/workflow-steps/${id}`);
  return data;
}

export async function createWorkflowStep(
  createWorkflowStep: CreateWorkflowStep
) {
  const { data } = await api.post('/workflow-steps', createWorkflowStep);
  return data;
}

export async function updateWorkflowStep(
  updateWorkflowStep: UpdateWorkflowStep
) {
  const { data } = await api.put(
    `/workflow-steps/${updateWorkflowStep.id}`,
    updateWorkflowStep
  );
  return data;
}

export function deleteWorkflowStep(id: number) {
  return api.delete(`/workflow-steps/${id}`);
}
